import { useSyncExternalStore } from 'react';

export const CURRENCIES = [
  { value: 'EUR', label: 'EUR · Euro', symbol: '€' },
  { value: 'MAD', label: 'MAD · Dirham marocain', symbol: 'MAD' },
  { value: 'USD', label: 'USD · Dollar américain', symbol: '$US' },
  { value: 'GBP', label: 'GBP · Livre sterling', symbol: '£' },
  { value: 'CHF', label: 'CHF · Franc suisse', symbol: 'CHF' },
  { value: 'CAD', label: 'CAD · Dollar canadien', symbol: '$CA' },
  { value: 'AED', label: 'AED · Dirham des Émirats', symbol: 'AED' },
] as const;
let currentCurrency = 'EUR';
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
export const getCurrency = () => currentCurrency;
export const setCurrency = (currency: string) => {
  if (!CURRENCIES.some((entry) => entry.value === currency) || currentCurrency === currency) return;
  currentCurrency = currency;
  listeners.forEach((listener) => listener());
};
export const useCurrency = () => useSyncExternalStore(subscribe, getCurrency, () => 'EUR');
export const currencySymbol = (currency = getCurrency()) =>
  CURRENCIES.find((entry) => entry.value === currency)?.symbol ?? currency;
export const currencyLabel = (text: string, currency = getCurrency()) =>
  text.replaceAll('€', currencySymbol(currency));
